import React from 'react'

/*
  Renders a CMS copy field that may contain rich text (bold, italic, links).

  The editor wraps content in <p>, which cannot live inside a heading, so a single
  paragraph is unwrapped and rendered inline. Plain strings from steps authored before
  these fields became rich text pass through untouched.
*/

const SINGLE_PARAGRAPH = /^\s*<p>((?:(?!<\/?p>)[\s\S])*)<\/p>\s*$/i

const ENTITIES = {
  '&nbsp;': ' ',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&apos;': "'",
}

/*
  The same copy with the markup taken off, for the places that can only hold text: a
  <select>'s <option> renders its children as text, so handing it "<span>Evening Spa</span>"
  shows the tags to the user.
*/
export const plainText = html => {
  if (html === null || html === undefined) return ''
  return String(html)
    // Block boundaries become spaces, so "<p>a</p><p>b</p>" is not "ab".
    .replace(/<\s*(br|\/p|\/div|\/h[1-6]|\/li)\s*\/?>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
    .replace(/&[a-z]+;|&#39;/gi, entity => ENTITIES[entity.toLowerCase()] ?? entity)
    .replace(/\s+/g, ' ')
    .trim()
}

const RichText = ({ html, as: Tag = 'span', className, ...rest }) => {
  if (html === null || html === undefined || html === '') return null

  const raw = String(html)
  const single = SINGLE_PARAGRAPH.exec(raw)

  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: single ? single[1] : raw }}
      {...rest}
    />
  )
}

export default RichText
